import medicalDashboard from '@/api/_admin-medical'
import MedicalActivityPanel from '@/components/medical-activity/Panel.vue'

const dateKey = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
const ranges = {
    today(now) { const key = dateKey(now); return [key, key] },
    yesterday(now) { const day = new Date(now); day.setDate(day.getDate() - 1); const key = dateKey(day); return [key, key] },
    week(now) { const first = new Date(now); first.setDate(first.getDate() - ((first.getDay() + 6) % 7)); return [dateKey(first), dateKey(now)] },
    month(now) { return [dateKey(new Date(now.getFullYear(), now.getMonth(), 1)), dateKey(now)] }
}

export default {
    name: 'dashboard-admin',
    components: { MedicalActivityPanel },
    data() {
        const today = dateKey(new Date())
        return {
            activityTab: 'overview',
            periode: 'today', startDate: today, endDate: today, serviceId: '', practitionerId: '',
            dateMode: 'single', dateSimple: today, plageDebut: today, plageFin: today, dateErreur: '',
            donnees: null, chargement: false, erreur: '', requete: 0,
            periodes: [
                { value: 'today', label: 'Aujourd’hui' },
                { value: 'week', label: 'Cette semaine' }, { value: 'month', label: 'Ce mois' }
            ]
        }
    },
    computed: {
        titrePeriode() {
            if (this.periode === 'custom') return this.dateMode === 'single' ? 'Date choisie' : 'Entre deux dates'
            return (this.periodes.find(item => item.value === this.periode) || this.periodes[0]).label
        },
        actualisation() {
            if (!this.donnees || !this.donnees.updated_at) return ''
            try { return new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: this.donnees.period.timezone }).format(new Date(this.donnees.updated_at)) }
            catch (_) { return '' }
        },
        maximumServices() { return Math.max(1, ...(this.donnees && this.donnees.metrics.by_service || []).map(row => row.consultations_count)) },
        moisRma() {
            if (!this.donnees || !this.donnees.rma || !this.donnees.rma.month) return ''
            const [year, month] = this.donnees.rma.month.split('-').map(Number)
            return new Intl.DateTimeFormat('fr-FR', { month: 'long', year: 'numeric' }).format(new Date(year, month - 1, 1))
        }
    },
    mounted() {
        if (typeof document !== 'undefined') document.addEventListener('pointerdown', this.fermerFiltreDateExterieur)
        this.charger()
    },
    beforeDestroy() {
        if (typeof document !== 'undefined') document.removeEventListener('pointerdown', this.fermerFiltreDateExterieur)
        this.requete += 1
    },
    methods: {
        fermerFiltreDateExterieur(event) {
            const filtre = this.$refs.filtreDate
            if (filtre && filtre.open && !filtre.contains(event.target)) filtre.open = false
        },
        choisirPeriode(value) {
            this.periode = value
            if (ranges[value]) [this.startDate, this.endDate] = ranges[value](new Date())
            this.charger()
        },
        appliquerFiltreDate() {
            const debut = this.dateMode === 'single' ? this.dateSimple : this.plageDebut
            const fin = this.dateMode === 'single' ? this.dateSimple : this.plageFin
            if (!debut || !fin || debut > fin) {
                this.dateErreur = 'Choisissez des dates valides, dans l’ordre chronologique.'
                return
            }
            this.dateErreur = ''
            this.startDate = debut
            this.endDate = fin
            this.periode = 'custom'
            this.$refs.filtreDate.open = false
            this.charger()
        },
        nombre(section, key) {
            const value = this.donnees && this.donnees[section] && this.donnees[section][key]
            return this.chiffre(value)
        },
        chiffre(value) { return value === null || value === undefined ? '—' : String(value) },
        async charger() {
            if (!this.startDate || !this.endDate || this.startDate > this.endDate) return
            const sequence = ++this.requete
            this.chargement = true; this.erreur = ''
            try {
                const response = await medicalDashboard.resume({ start_date: this.startDate, end_date: this.endDate,
                    ...(this.serviceId ? { service_id: this.serviceId } : {}),
                    ...(this.practitionerId ? { practitioner_id: this.practitionerId } : {}) })
                if (sequence === this.requete) this.donnees = response
            } catch (_) {
                if (sequence === this.requete) { this.donnees = null; this.erreur = 'Les indicateurs médicaux n’ont pas pu être chargés.' }
            } finally { if (sequence === this.requete) this.chargement = false }
        }
    }
}
